import React, { useState } from "react";
import classes from "./SubscriptionPage.module.css";
import { motion } from "framer-motion";
import { FaCheck } from "react-icons/fa6";
import LinedSection from "../component/LinedSection";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const plans = [
  {
    id: 1,
    name: "Passe Diário",
    price: "3MT",
    amount: "3.00",
    description: "24 Horas de Jogos",
  },
  {
    id: 2,
    name: "Passe Semanal",
    price: "20MT",
    amount: "20.00",
    description: "7 Dias de Acesso",
  },
  {
    id: 3,
    name: "Passe Mensal",
    price: "50MT",
    amount: "50.00",
    description: "30 Dias de Jogos",
  },
];

const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(1);
  const [mobile, setMobile] = useState("");

  const navigate = useNavigate();
  const {t}=useTranslation();

  return (
    <main className={classes.main}>
      <div className={classes.glowLayer} />

      <LinedSection />

      <motion.section
        className={classes.container}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >

        <div className={classes.bgGlowOne} />
        <div className={classes.bgGlowTwo} />

        <div className={classes.topLogoWrap}>
          <img
            src="/images/logo2.png"
            alt="UV Gaming"
            className={classes.logoImg}
          />
        </div>

        <div className={classes.headingWrap}>
          <h1 className={classes.title}>
            {t("34")}
            <span>{" "}{t("35")}</span>
          </h1>
          {/* <p className={classes.subtitle}>
            Passez au niveau supérieur avec une nouvelle expérience de jeu
          </p> */}
        </div>

        <div className={classes.card}>
          <div className={classes.tabSwitch}>
            <button
              type="button"
              className={`${classes.tabBtn}`}
              onClick={() => navigate("/login")}
            >
              {t("36")}
            </button>

            <button
              type="button"
              className={`${classes.tabBtn} ${classes.tabBtnActive}`}
            >
              {t("37")}
            </button>
          </div>

          <div className={classes.formBlock}>
            <label className={classes.label}>{t("38")}</label>

            <div className={classes.phoneField}>
              <div className={classes.phoneCode}>+255</div>
              <input
                type="tel"
                placeholder={t("39")}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className={classes.phoneInput}
              />
            </div>
          </div>

          <div className={classes.plansWrap}>
            {/* {plans.map((plan) => {
              const isActive = selectedPlan === plan.id;

              return (
                <button
                  key={plan.id}
                  type="button"
                  className={`${classes.planCard} ${isActive ? classes.planCardActive : ""
                    }`}
                  onClick={() => setSelectedPlan(plan.id)}
                >
                  <div className={classes.planInfo}>
                    <div
                      className={`${classes.planName} ${isActive ? classes.planNameActive : ""
                        }`}
                    >
                      {plan.name}
                    </div>

                    <div
                      className={`${classes.planDesc} ${isActive ? classes.planDescActive : ""
                        }`}
                    >
                      {plan.description}
                    </div>

                    <div
                      className={`${classes.planPrice} ${isActive ? classes.planPriceActive : ""
                        }`}
                    >
                      {plan.price}
                    </div>
                  </div>

                  <div
                    className={`${classes.selector} ${isActive ? classes.selectorActive : ""
                      }`}
                  >
                    {isActive && <FaCheck />}
                  </div>
                </button>
              );
            })} */}


            <button
              type="button"
              className={`${classes.planCard} ${selectedPlan === 1 ? classes.planCardActive : ""
                }`}
              onClick={() => setSelectedPlan(1)}
            >
              <div className={classes.planInfo}>
                <div
                  className={`${classes.planName} ${selectedPlan === 1 ? classes.planNameActive : ""
                    }`}
                >
                  {t("40")}
                </div>

                <div
                  className={`${classes.planDesc} ${selectedPlan === 1 ? classes.planDescActive : ""
                    }`}
                >
                  {t("41")}
                </div>

                <div
                  className={`${classes.planPrice} ${selectedPlan === 1 ? classes.planPriceActive : ""
                    }`}
                >
                  3MT
                </div>
              </div>

              <div
                className={`${classes.selector} ${selectedPlan === 1 ? classes.selectorActive : ""
                  }`}
              >
                {selectedPlan === 1 && <FaCheck />}
              </div>
            </button>

            <button
              type="button"
              className={`${classes.planCard} ${selectedPlan === 2 ? classes.planCardActive : ""
                }`}
              onClick={() => setSelectedPlan(2)}
            >
              <div className={classes.planInfo}>
                <div
                  className={`${classes.planName} ${selectedPlan === 2 ? classes.planNameActive : ""
                    }`}
                >
                  {t("42")}
                </div>

                <div
                  className={`${classes.planDesc} ${selectedPlan === 2 ? classes.planDescActive : ""
                    }`}
                >
                  {t("43")}
                </div>

                <div
                  className={`${classes.planPrice} ${selectedPlan === 2 ? classes.planPriceActive : ""
                    }`}
                >
                  20MT
                </div>
              </div>

              <div
                className={`${classes.selector} ${selectedPlan === 2 ? classes.selectorActive : ""
                  }`}
              >
                {selectedPlan === 2 && <FaCheck />}
              </div>
            </button>

            <button
              type="button"
              className={`${classes.planCard} ${selectedPlan === 3 ? classes.planCardActive : ""
                }`}
              onClick={() => setSelectedPlan(3)}
            >
              <div className={classes.planInfo}>
                <div
                  className={`${classes.planName} ${selectedPlan === 3 ? classes.planNameActive : ""
                    }`}
                >
                  {t("44")}
                </div>

                <div
                  className={`${classes.planDesc} ${selectedPlan === 3 ? classes.planDescActive : ""
                    }`}
                >
                  {t("45")}
                </div>

                <div
                  className={`${classes.planPrice} ${selectedPlan === 3 ? classes.planPriceActive : ""
                    }`}
                >
                  50MT
                </div>
              </div>

              <div
                className={`${classes.selector} ${selectedPlan === 3 ? classes.selectorActive : ""
                  }`}
              >
                {selectedPlan === 3 && <FaCheck />}
              </div>
            </button>

          </div>

          <button type="button" className={classes.confirmBtn}
            onClick={() => navigate("/otp")}
          >
            {t("46")}
          </button>

          <div className={classes.bottomNote}>
            {t("47")}
          </div>
        </div>

        <div className={classes.footerText}>
          © UVCANN SOLUTIONS LLP
        </div>
      </motion.section>
    </main>
  );
};

export default SubscriptionPage;